// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/permission'
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue'
import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import VueClipboard from 'vue-clipboard2'
import globals from './globals'
import Popper from 'popper.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import messages from './mixins/messages'
import Toasted from 'vue-toasted'
Vue.use(Toasted)
Vue.use(VueClipboard)
Vue.use(VueVideoPlayer)
flatpickr.localize(Turkish)

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(VueClipboard)

// Global RTL flag
Vue.mixin({
  data: globals
})
Vue.mixin(messages)

if (globals().baseDomainMi) {
  router.addRoutes([
    {
      path: '/kayit',
      name: 'Kayit',
      component: () => import('@/views/kayit-yeni/kayit')
    },
    {
      path: '/uzaktan-egitim-kayit',
      name: 'UzaktanEgitimKayit',
      component: () => import('@/views/kayit-yeni/uzaktan-egitim-kayit')
    },
    {
      path: '/yuzyuze-egitim-kayit',
      name: 'YuzyuzeEgitimKayit',
      component: () => import('@/views/kayit-yeni/yuzyuze-egitim-kayit')
    }
  ])
} else if (globals().tugvaMi || globals().siracMi) {
  router.addRoutes([
    {
      path: '/kayit',
      name: 'Kayit',
      component: () => import('@/views/kayit-yeni/uzaktan-egitim-kayit')
    }
  ])
} else {
  router.addRoutes([
    {
      path: '/kayit',
      name: 'Kayit',
      component: () => import('@/views/kayit-yeni/kapali')
    }
  ])
}

window.lokum = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
